"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = void 0;

var Connector = /*#__PURE__*/function () {
  /**
   * @param actions - Methods bound to a zustand store that tracks the state of the connector.
   * Actions are used by the connector to report changes in connection status.
   */
  function Connector(actions) {
    _classCallCheck(this, Connector);

    this.actions = actions;
  }
  /**
   * Initiate a disconnect.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  _createClass(Connector, [{
    key: "deactivate",
    value: function deactivate() {
      this.actions.reportError(undefined);
    }
  }]);

  return Connector;
}();

exports.Connector = Connector;